export const REFRESH_TOKEN_URL = 'v1/auth/token/refresh';
export const INTEGRATION_SETTING_POPUP_ID = 'INTEGRATION_SETTING_POPUP_ID';
export const LATEST_VIEWED_PROJECT_ID = 'LATEST_VIEWED_PROJECT_ID';
export const EMAIL_REGEX = /^([a-zA-Z0-9._%-+]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})$/;
export const KNOWLEDGE_BASE_FILE_EXTENSIONS = [
  '.pdf',
  '.docx',
  '.txt',
  '.md',
  '.html',
  '.xls',
  '.xlsx',
  '.csv',
  '.tsv',
  '.faq',
];

export const INTERNAL_SERVER_ERROR_MESSAGE = 'Internal server error';
export const GET_FRESHDESK_AGENTS_FRIENDLY_ERROR =
  'Unable to fetch Freshdesk agents due to a server error.';
export const GET_FRESHDESK_GROUPS_FRIENDLY_ERROR =
  'Unable to fetch Freshdesk groups due to a server error.';
export const ERROR_MESSAGE_FRIENDLY =
  'Yikes! It seems our server is taking a coffee break. Please refresh the page.';
export const ERROR_MESSAGE_CONTACT =
  'Something went wrong. Please contact our system administrator.';
export const ERROR_MESSAGE_PLAYGROUND = {
  BACKEND_ACTIVE_PLAN: 'Account has no active plan',
  FRIENDLY_ACTIVE_PLAN: `The Playground is disabled.\n Activate a subscription to continue.`,
  FRIENDLY_ERROR_MESSAGE: `The Playground is temporarily unavailable due to maintenance.\n Please try again later.`,
};
export const URL_REGEX =
  /('https?:\/\/(www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&/=]*)')/g;
// [text](url): the text runs to the first "](", the url to the first ")".
export const MARKDOWN_TO_URL_REGEX = /\[([^\]\n\r]*(?:\](?!\()[^\]\n\r]*)*)\]\(([^)\n\r]*)\)/gim;

export const COSSUPORT_DEMO_PAGE = 'https://cosupport.ai/demo';

export const TRENGO_MAIN_PAGE = 'https://app.trengo.com';

export const CHROME_EXTENSION_LINK =
  'https://chromewebstore.google.com/detail/kcpfdjeibdkkalafhdfjicjkcealkkhc?utm_source=item-share-cb';

export const NOTION_PAGES = {
  HELP_PAGE: 'https://cosupport.notion.site/1931fff62e46808f8375eb53ad217661',
};
export const COSSUPORT_TERMS = 'https://cosupport.ai/terms-of-services';
export const GETTING_STARTED_GUIDE =
  'https://www.notion.so/nlplabai/Getting-started-with-CoSupport-AI-1f41fff62e46804f9d32e795bf7a00e6';

export const ERROR_COUNTRIES = ['RU', 'CU', 'IR', 'KP', 'SY', 'BY'];
export const ISO_DATE_FORMAT = 'YYYY-MM-DDTHH:mm:ss';
export const DATE_INPUT_FORMAT = 'MM/DD/YYYY';
export const DATE_FORMAT_MMM_DD_YYYY = 'MMM DD, yyyy';
export const EMAIL = {
  SUPPORT: 'support@cosupport.ai',
};

// Zendesk OAuth: how often and how long to poll for the consent to be granted (auth_status "ok").
export const AUTH_STATUS_POLL_INTERVAL_MS = 3000;
export const AUTH_STATUS_POLL_TIMEOUT_MS = 3 * 60 * 1000;
